import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";

// Generate token
// export const getLogin = (model) => {
//     // const model={"id":"-1"}
//     const url = `${CONFIG.BASE_URL}/login`;
//     return axios.post(url, model)
//         .then((response) => {
//           localStorage.setItem("token",response.data.access_token)

//         });
// }

//get state
export const getLogin = (model) => {
  console.log(model);
  const url = `${CONFIG.BASE_URL}/user/login.json`;
  return axios.post(url, model).then((response) => {
    if (response.data.status) {
      //alert(response.data.roles[0].role_name);
      localStorage.setItem("status", response.data.status);
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("username", response.data.username);
      localStorage.setItem("roleid", response.data.roleid);
      localStorage.setItem("userrole", response.data.userrole);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem("message", response.data.message);
      localStorage.setItem("user_status", response.data.user_status);
      localStorage.setItem("lmspwd", response.data.lmspwd);
      localStorage.setItem("instutionbelongto", response.data.institutetype);
      localStorage.setItem("profilepic", response.data.profilepic);
      localStorage.setItem(
        "universityid",
        response.data.university ? response.data.university[0]["id"] : ""
      );
    }
    return response.data;
  });
};

export const getSignup = (model) => {
  console.log(model);
  const url = `${CONFIG.BASE_URL}/signup`;
  return axios.post(url, model).then((response) => {
    return response.data;
  });
};

export const getLogout = (props) => {
  localStorage.removeItem("token");
  localStorage.removeItem("status");
  localStorage.removeItem("username");
  localStorage.removeItem("roleid");
  localStorage.removeItem("userrole");
  localStorage.removeItem("email");
  localStorage.removeItem("message");
  localStorage.removeItem("user_status");
  localStorage.removeItem("lmspwd");
  localStorage.removeItem("lmspwd");
  localStorage.removeItem("universityid");
  localStorage.removeItem("profilepic");

  //history.push("/login");
  window.location.reload();
  //return true;
};

export const username = () => {
  return localStorage.getItem("username");
};

export const universityid = () => {
  return localStorage.getItem("universityid");
};

export const instutionbelongto = () => {
  return localStorage.getItem("instutionbelongto");
};

export const email = () => {
  return localStorage.getItem("email");
};

export const lmspwd = () => {
  return localStorage.getItem("lmspwd");
};

export const roleid = () => {
  return localStorage.getItem("roleid");
};

export const role = () => {
  return localStorage.getItem("userrole");
};

export const token = () => {
  return localStorage.getItem("token");
};

export const user_status = () => {
  return localStorage.getItem("user_status");
};

export const profile_pic = () => {
  return localStorage.getItem("profilepic");
};

// export const urlAccess  = () => {{
//     var auth = JSON.parse(localStorage.getItem('token'))
//     if(auth){
//       history.goBack()
//     }else{
//       props.history.push("/");
//     }
// }

// //get state map details
// export const getStateMapDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getmapdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all ministry
// export const selectAllMinistry = (model) => {
//   const url = `${CONFIG.BASE_URL}/master/1/api/getallministry`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all department
// export const selectAllDepartment = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getalldepartment`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all Central Gov Details
// export const getCentralGovDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getsearchcentrelgovdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get single central Gov Details
// export const getSingleCentralGovDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getsinglecentrelgovdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get single central Gov Details
// export const getFilterDepartment = (model) => {
//     const url = `${CONFIG.BASE_URL}/govtinit/1/api/selectcentraldepartment`;
//     return axios.post(url, model, getAuthHeader())
//         .then((response) => {
//             return response.data;
//         });
//   }
